/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskCustomRulesUpdate } from "../funcs/riskCustomRulesUpdate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskCustomDetectionRule } from "../models/components/riskcustomdetectionrule.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateCustomDetectionRuleRequest,
  UpdateCustomDetectionRuleSecurity,
} from "../models/operations/updatecustomdetectionrule.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskUpdateCustomDetectionRuleMutationVariables = {
  request: UpdateCustomDetectionRuleRequest;
  security?: UpdateCustomDetectionRuleSecurity | undefined;
  options?: RequestOptions;
};

export type RiskUpdateCustomDetectionRuleMutationData = RiskCustomDetectionRule;

export type RiskUpdateCustomDetectionRuleMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateCustomDetectionRule risk
 *
 * @remarks
 * Update a custom detection rule.
 */
export function useRiskUpdateCustomDetectionRuleMutation(
  options?: MutationHookOptions<
    RiskUpdateCustomDetectionRuleMutationData,
    RiskUpdateCustomDetectionRuleMutationError,
    RiskUpdateCustomDetectionRuleMutationVariables
  >,
): UseMutationResult<
  RiskUpdateCustomDetectionRuleMutationData,
  RiskUpdateCustomDetectionRuleMutationError,
  RiskUpdateCustomDetectionRuleMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskUpdateCustomDetectionRuleMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskUpdateCustomDetectionRule(): MutationKey {
  return ["@gram/client", "customRules", "update"];
}

export function buildRiskUpdateCustomDetectionRuleMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskUpdateCustomDetectionRuleMutationVariables,
  ) => Promise<RiskUpdateCustomDetectionRuleMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskUpdateCustomDetectionRule(),
    mutationFn: function riskUpdateCustomDetectionRuleMutationFn({
      request,
      security,
      options,
    }): Promise<RiskUpdateCustomDetectionRuleMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskCustomRulesUpdate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
